import  { useEffect } from "react";
import { useLanguage } from "../Translations/LenguageContext";
import { PiCheck, PiWarning } from "react-icons/pi";

const PopupMex = ({ active, type, message, onClose }) => {
    const { t } = useLanguage();
    const popupClass = type === "success" ? "popup_success" : type === "error" ? "popup_error" : "popup";

    useEffect(() => {
        if (active) {
            const timer = setTimeout(() => {
                const popup = document.getElementById(popupClass);
                popup.style.animation = "fadeOut 3s linear";
                setTimeout(() => {
                    if (onClose) onClose();
                }, 400);
            }, 4000);

            return () => clearTimeout(timer);
        }
    }, [active, onClose, popupClass]);

    if (!active) {
        return null;
    }

    return (
        <div id={popupClass} className={`popup_cont ${type == "success" ? "popup_cont_success" : "popup_cont_error"}`}>
            <p className="popup_mex">
                <i>{type === "success" ? <PiCheck/> : <PiWarning/>}</i>
                {message}
            </p>
            <div className="popup_loading_bar"></div>
        </div>
    );
};

export default PopupMex;
